<template>
  <div class="component-content configuration-frame">
    <div class="component-content-scroll">
      <div class="component-content-title">Select your frame details</div>
      <!-- Rimossa la lista con Personal title -->
      <component
        v-bind:is="getContent"
        :results="results"
        :components="components"
        v-on:set-frame-finish="updateFrameFinish"
      ></component>
    </div>
    <div class="buttonset flexend">
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import frameFinish from "./sub-components/frame-finish.vue";

Vue.component("frame-finish", frameFinish);

export default {
  name: "configuration-frame",
  data() {
    return {
      subSteps: [
        {
          name: "frame-finish",
          template: "frame-finish",
          activeItem: "frame-finish",
        },
      ],
      currentSubStep: 0,
    };
  },
  computed: {
    getContent: function () {
      return this.subSteps[this.currentSubStep].template;
    },
  },
  props: ["bike", "configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      if (this.currentSubStep==0 && this.results.frame.finish==null) {
        this.$emit('set-error', 'Please select a frame finish')
        return false;
      }
      this.$emit("go-next");
    },
    updateFrameFinish: function (e) {
      this.$emit("set-frame-finish", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-frame {
  ul {
    list-style: none;
    padding: 0;
    margin-top: 20px;
    li {
      display: inline-block;
      margin-right: 25px;
      text-transform: uppercase;
      color: #888;
      cursor: pointer;
      &.active {
        position: relative;
        color: black;
        &::after {
          content: "";
          width: 100%;
          border-bottom: 1px solid black;
          position: absolute;
          left: 0;
          bottom: -4px;
        }
      }
    }
  }
}
</style>

